export default __webpack_public_path__ + "static/media/no_results_img.5bfc1238.svg";